import * as React from 'react';
import { AddressSearchForm } from '@grandvisionhq/locations';

const AddressLookup = ({ hasDisplayError =false , isDisplayIsValid =false , errorMessage , inputFieldName , label , onResult , isRequired =true , setIsTouched , streetName , updateForm  })=>/*#__PURE__*/ React.createElement("label", {
        className: "address-lookup form-control"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "form-control__label"
    }, label, isRequired && /*#__PURE__*/ React.createElement("span", {
        className: "form-control__asterisk"
    }, "*")), /*#__PURE__*/ React.createElement(AddressSearchForm, {
        inputFieldName: inputFieldName,
        isInvalid: hasDisplayError,
        isValid: isDisplayIsValid,
        onResult: onResult,
        setIsTouched: setIsTouched,
        streetName: streetName,
        updateForm: updateForm
    }), hasDisplayError && /*#__PURE__*/ React.createElement("span", {
        id: "address-lookup",
        className: "form-control__error"
    }, errorMessage))
;

export { AddressLookup };
//# sourceMappingURL=AddressLookup.js.map
